import React, { useCallback, useEffect, useRef } from "react";
import { ISocket } from "./SocketProvider.types";
import { SocketContext } from "./SocketProvider.context";
import { initializeSocket } from "./SocketProvider.utils";
import { LinearProgress } from "@mui/material";
import { useOrderContext } from "./SocketProvider.hooks";
import { useAuthProvider } from "../Authentication";
import { OrderNotificationSnackbarListener } from "./OrderNotificationSnackbarListener";

export const SocketProvider: React.FC<{ children: React.ReactNode }> = (
  props,
) => {
  const [appSocket, setAppSocket] = React.useState<ISocket>(null);
  const { user_uuid } = useAuthProvider();

  // ----------------------------
  // 🔊 Notification Sound Player
  // ----------------------------
  const notificationAudioRef = useRef<HTMLAudioElement | null>(null);

useEffect(() => {
  const audio = new Audio("/assets/sounds/order_notification.mp3");
  audio.addEventListener("error", () => {
    console.error("❌ Audio failed to load. Check file path.");
  });
  notificationAudioRef.current = audio;
  
}, []);

  const playNotificationSound = useCallback(() => {
    if (!notificationAudioRef.current) return;
    notificationAudioRef.current.currentTime = 0;
    console.log("<--- Playing sound --->")
    notificationAudioRef.current
      .play()
      .then(() => console.log("Sound played"))
      .catch((err) => console.error("Audio play blocked:", err));
  }, []);


  useEffect(() => {
    if (!user_uuid) return;

    const newSocket = initializeSocket(user_uuid);

    newSocket.on("connect", () => {
      console.log("✅ Socket connected:", newSocket.id);
      setAppSocket(newSocket);
    });

    newSocket.on("disconnect", () => {
      console.log("❌ Socket disconnected");
    });

    newSocket.on("connect_error", (err) => {
      console.error("⚠️ Socket connection error:", err.message);
    });

    return () => {
      newSocket.disconnect();
    };
  }, [user_uuid]);

  const chatHookValues = useOrderContext(appSocket, playNotificationSound);

  if (user_uuid && !appSocket) return <LinearProgress />;

  return (
    <SocketContext.Provider value={{
      socket: appSocket,
      playNotificationSound,
      ...chatHookValues
    }}>
      {props.children}
      <OrderNotificationSnackbarListener />
    </SocketContext.Provider>
  );
};
